import React from 'react';

import { DetailPageLayout } from 'src/components/common';
import { PeosDetailsCompanyInformationForm } from 'src/components/peo';
import { usePeoParamId } from 'src/hooks/peo';

export const PeoDetailCompanyInformationPage: React.FC = () => {
  const peoId = usePeoParamId();

  return (
    <DetailPageLayout titleContent="Company Information">
      <PeosDetailsCompanyInformationForm peoId={peoId} />
    </DetailPageLayout>
  );
};
